import React from 'react'
import classNames from 'classnames'
import { FontAwesome } from '@zooz/generic-ui-components'
import { Link } from 'react-router-dom'

import style from './style.scss'

export interface ActivationButtonProps {
  text?: string,
  disabled?: boolean,
  link: string,
  collapsed: boolean
}

const ActivationButton: React.FC<ActivationButtonProps> = ({ text, disabled, link, collapsed }) => {
  if (disabled) {
    return null
  }

  const styleClass = classNames(style['activate-account-button'], collapsed ? style['activate-account-button-no-text'] : undefined)

  return (
    <Link
      to={link}
      className={styleClass}
      data-test='ActivationButton'
    >
      <FontAwesome data-test='ActivationButton__icon' className={style.icon} icon='rocket' />
      <span className={style.text} data-test='activate-account'>{text}</span>
    </Link>
  )
}

export default ActivationButton
